export class CategoryItemReq {
    categoryId: number;
    itemSubCategoryId: number;
    itemId?: number;
}